module.exports = __webpack_public_path__ + "static/media/github-line.a4cfde1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/github-line.svg
// module id = 1095
// module chunks = 0